import React from 'react';
import { CSVLink } from 'react-csv';
import type { LinkProps } from 'react-csv/components/Link';

// react-csv class component is incompatible with @types/react@18's stricter JSX check
const CsvLinkComponent = CSVLink as React.ComponentType<LinkProps>;

import i18n from '@client/utils/i18n';
import { CsvDataPoint } from '@ledium/types';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Button } from '@mui/material';

interface DownloadSpectrumCsvProps {
    data: CsvDataPoint[];
    filename: string;
}

const DownloadSpectrumCsv = ({ data, filename }: DownloadSpectrumCsvProps) => (
    <CsvLinkComponent style={{ textDecoration: 'none' }} enclosingCharacter="" filename={filename} data={data}>
        <Button variant="contained" startIcon={<GetAppIcon />}>
            <span>{i18n('download_spectrum_csv')}</span>
        </Button>
    </CsvLinkComponent>
);

export default DownloadSpectrumCsv;
